import { createTheme } from '@mui/material/styles';
import { COLORS, TYPOGRAPHY } from '@elevair/shared';

// Extend MUI's palette to include our custom colors
declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
  }
  interface PaletteOptions {
    neutral?: PaletteOptions['primary'];
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary, // #E07A5F - Coral
      light: '#E9988A',
      dark: '#C66549',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: COLORS.secondary, // #1D3557 - Navy
      light: '#2E4A6B',
      dark: '#142540',
      contrastText: '#FFFFFF',
    },
    success: {
      main: COLORS.status.success, // #38A169
      light: '#68B684',
      dark: '#2B7A4E',
    },
    warning: {
      main: COLORS.status.warning, // #D69E2E
      light: '#E4B54A',
      dark: '#A67A1E',
    },
    error: {
      main: COLORS.status.error, // #E53E3E
      light: '#EB6B6B',
      dark: '#B32F2F',
    },
    info: {
      main: COLORS.status.info, // #3182CE
      light: '#5A9BD8',
      dark: '#2563A0',
    },
    neutral: {
      main: COLORS.text, // #2D3436
      light: '#636E72',
      dark: '#1E2426',
    },
    background: {
      default: COLORS.background, // #FDF8F3
      paper: '#FFFFFF',
    },
    text: {
      primary: COLORS.text, // #2D3436
      secondary: '#636E72',
    },
  },
  typography: {
    fontFamily: TYPOGRAPHY.fontFamily.body,
    h1: {
      fontFamily: TYPOGRAPHY.fontFamily.heading,
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontFamily: TYPOGRAPHY.fontFamily.heading,
      fontWeight: 700,
      fontSize: '2rem',
    },
    h3: {
      fontFamily: TYPOGRAPHY.fontFamily.heading,
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontFamily: TYPOGRAPHY.fontFamily.heading,
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontFamily: TYPOGRAPHY.fontFamily.heading,
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontFamily: TYPOGRAPHY.fontFamily.heading,
      fontWeight: 600,
      fontSize: '1rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 20px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          },
        },
        containedPrimary: {
          backgroundColor: COLORS.accent, // Use Teal for CTAs
          '&:hover': {
            backgroundColor: '#238C7F',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
        },
      },
    },
  },
});
